<template>
  <b-card tag="section"
          header-class="bg-lightgreen">
    <b-card-title class="h5">
      <b-icon icon="cloud-upload-fill"></b-icon>
      上傳圖檔
    </b-card-title>
    <img :src="imageUrl"
         alt="upload image"
         class="upload-image" />
    <b-form @submit.prevent="$emit('send-request')">
      <label for="file" class="file-input">
        <div>{{ formImage ? formImage.name : '請上傳圖片' }}</div>
        <input type="file" name="" id="file" @change="updateImage" accept="image/png, image/jpeg" ㄥ>
      </label>
      <b-form-select v-model="formModelID"
                     :options="model"
                     class="mb-3"></b-form-select>
      <b-button variant="success"
                class="d-block"
                type="submit"
                :disabled="isLoad"
                block>
        <b-icon icon="wrench"></b-icon>
        {{ isLoad ? '計算中...' : '計算結果' }}
      </b-button>
      <b-progress v-if="isLoad"
                  :value="value"
                  show-progress
                  animated
                  class="mt-3"></b-progress>
    </b-form>
  </b-card>
</template>

<script>

export default {
  name: 'UploadFileCard',
  components: {},
  filters: {},
  mixins: {},
  props: {
    isLoad: {
      type: Boolean,
      required: true
    },
    model: {
      type: Array,
      required: true
    },
    form: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      defaultImage: '@/assets/images/upload.png',
      value: 20
    }
  },
  computed: {
    imageUrl () {
      return this.formImage
        ? this.createImageUrl(this.formImage)
        : require('@/assets/images/upload.png')
    },
    formImage: {
      get () {
        return this.form.image
      },
      set (value) {
        this.$emit('change-form-image', value)
      }
    },
    formModelID: {
      get () {
        return this.form.modelID
      },
      set (value) {
        this.$emit('change-form-model-id', value)
      }
    }
  },
  watch: {
    isLoad: {
      handler (data) {
        this.value = 50
        if (!data) return (this.value = 100)
      }
    }
  },
  created () {},
  methods: {
    createImageUrl (image) {
      return URL.createObjectURL(image)
    },
    updateImage (e) {
      this.formImage = e.target.files[0]
    }
  }
}
</script>

<style lang="scss" scoped>
  .bg-lightgreen {
    background-color: #28a74520;
  }
  .upload-image {
    max-width: 100%;
    margin-bottom: 12px;
  }
  .file-input {
    display: block;
    font-size: 0;
    border-radius: 4px;
    border: 1px solid #ced4ca;
    div {
      content: '';
      width: calc(100% - 75px);
      font-size: 12px;
      padding: 6px 12px;
      font-size: 16px;
      display: inline-block;
      white-space: nowrap;
    }
    &::after {
      content: '上傳';
      text-align: center;
      width: 75px;
      display: inline-block;
      border-left: 1px solid #ced4ca;
      font-size: 16px;
      padding: 6px 12px;
      background-color: #e9ecef;
    }

    &:focus {
      box-shadow: 0 0 0 1px #80bdff, 0 0 0 4px rgba(0, 123, 255, 0.25);
    }

    input {
      display: none;
    }
  }
</style>
